export { isMediaClientError, getMediaClientErrorReason } from './helpers';
/**
 * Base class for media errors
 */

export class BaseMediaClientError extends Error {
  constructor(message) {
    super(message); // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget

    this.message = message;
    Object.setPrototypeOf(this, new.target.prototype); // https://v8.dev/docs/stack-trace-api

    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(this, new.target);
    }
  }

}